import { useEffect, useState } from "react";
import { getCurrentRound } from "../api/round";
import type { RoundCurrent } from "../types/api";
import { subscribeLive } from "../aim/liveBus";

const apiBase = (
  (import.meta as unknown as { env: Record<string, string> }).env.VITE_AIM_API_BASE || ""
).replace(/\/$/, "");

const empty: RoundCurrent = { roundId: null, status: "NO_ACTIVE_ROUND", targets: [] };

// Target discovery for the multi-target LIVE round (event hardening P0-P2):
// which target(s) the Portal's OBJETIVOS selector should offer, without
// calling any /api/admin/* route. Same shared SSE-or-poll signal as every
// other LIVE panel (apps/portal/src/aim/liveBus.ts) — a round.started/
// round.closed/round.reset event refetches this almost instantly.
export function useCurrentRound(enabled: boolean) {
  const [data, setData] = useState<RoundCurrent>(empty);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setData(empty);
      setError(false);
      return;
    }
    let stopped = false;
    const abort = new AbortController();
    async function refresh() {
      try {
        const next = await getCurrentRound(abort.signal);
        if (!stopped) {
          setData(next);
          setError(false);
        }
      } catch {
        if (!stopped) setError(true);
      }
    }
    void refresh();
    const unsubscribe = subscribeLive(apiBase, () => void refresh());
    return () => {
      stopped = true;
      abort.abort();
      unsubscribe();
    };
  }, [enabled]);

  return { data, error };
}
